<template>
    <div class="confirm">
        <div>
            <a href="/submittal-manager" class="button back simple alternate">Projects</a>
        </div>
        <div>
            <save-button
                :class="{faded: fadeSave}"
                v-on:clicked="save"
                :saving="saving"
                :finished-text="saveButtonFinishedText"
                >
            </save-button>
            <button type="submit" :class="{faded: fadeNext}" @click="next()">
                <span v-text="nextButtonText"></span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        fadeSave: {default: false},
        fadeNext: {default: false},
        saving: {},
        saveButtonFinishedText: {},
        nextButtonText: {
            default: 'Next'
        }
    },

    methods: {
        save() {
            this.$emit('save');
        },

        next() {
           this.$emit('next');
        },
    },
};
</script>
